import React from 'react';
import { SageTokens, IconCard, Icon, EmptyState, SageClassnames, Frame } from '@kajabi/sage-react';
import { ERROR_TYPES } from 'common/components/CopyMagic/constants';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';

const ErrorMessageDefault = () => {
  const { error } = useUiResourceContext();

  if (!error) return null;

  const iconColor =
    error?.type === ERROR_TYPES.WARN ? IconCard.COLORS.WARNING : IconCard.COLORS.DANGER;

  return (
    <EmptyState
      icon={SageTokens.ICONS.MEGAPHONE}
      backgroundColor={SageTokens.COLOR_PALETTE.RED_300}
      size={EmptyState.SIZES.COMPACT}
      text={error.message}
      data-testid="copy-magic-error-message-default"
    />
  );
};

export default ErrorMessageDefault;
